module.exports = __webpack_public_path__ + "static/img/mission-modular-1.863b59fe.png";